    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-plus"></i>&nbsp;Crear combustible</h5>
            </div>
        </div>
        <hr>
        <form #formNuevoCombustible="ngForm" (ngSubmit)="formSubmit(formNuevoCombustible)" novalidate="">
            <div class="container-fuid" style="height: 200px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
                <div class="row">
                    <div class="col col-12">
                        <div class="form-group">
                            <label class="form-label">Tipo:</label>
                            <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Gasolina, Diesel, etc" name="txtTipo" #txtTipo="ngModel" [(ngModel)]='CombustibleRQ.tipo' maxlength="15" required>
                        </div>

                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col col-12">
                        <label class="form-label">Descripción:</label>
                        <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Descripción" name="txtDescripcion" #txtDescripcion="ngModel" [(ngModel)]='CombustibleRQ.descripcion' maxlength="25" required>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-end">
                        <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                                    <i class="fa fa-arrow-left"></i>
                                    Regresar
                        </button>
                        <button [disabled]="!formNuevoCombustible.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                            Aceptar
                            <i class="fa fa-check"></i>
                        </button>
                    </div>
                </div>
            </div>   
        </form>
    </div>